const ParentFmt = (d) => d ? new Date(d).toLocaleDateString('ar-EG') : '—';

export default ParentFmt;